export default __webpack_public_path__ + "static/media/Newsletter 028.510ea25c.png";